import React from 'react'
import { HandThumbsUpFill } from 'react-bootstrap-icons'

export default function HandThumbsSidewaysFill({ className = '', ...props }) {
  return <HandThumbsUpFill className={`rotate-90 ${className}`} {...props} />
}
